// @flow
import { createReducer } from "reduxsauce";
import Types from "../actions/Types";

// Init State
export const INITIAL_STATE = {
  reports: null,
  errorMessage: null,
  successMessage: null,
  isLoading: false,
  isExportLoading: false,
  sales: null,
  salesItem: null,
  salesStatus: null,
};

/* Generic error message */
const genericError = "Something went wrong";

/* Get Reports */
export const getReports = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true
  };
};

export const getReportsSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    reports: action.reports,
    isLoading: false
  };
};

export const getReportsFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isLoading: false,
  errorMessage: action.error || genericError
});

// Export Reports
export const exportReports = (state: Object = INITIAL_STATE, action) => {
  return {
    ...state,
    isExportLoading: action.link
  };
};

export const exportReportsSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    isExportLoading: false
  };
};

export const exportReportsFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isExportLoading: false,
  errorMessage: action.error || genericError
});

/* Get Reports */
export const getSales = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true
  };
};

export const getSalesSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    sales: action.sales,
    isLoading: false
  };
};

export const getSalesFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isLoading: false,
  errorMessage: action.error || genericError
});

/* Get Reports */
export const getSalesItemDetails = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true
  };
};

export const getSalesItemDetailsSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    salesItem : action.salesItem,
    isLoading: false
  };
};

export const getSalesItemDetailsFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isLoading: false,
  errorMessage: action.error || genericError
});

// Clear Reports
export const clearReports = () => INITIAL_STATE;

/* GET SALES STATUS */
export const getSalesStatus = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    errorMessage: null
  };
};

export const getSalesStatusSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    salesStatus: action.salesStatus,
  };
};

export const getSalesStatusFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: action.errorMessage || genericError,
  };
};

const ACTION_HANDLERS = {
  [Types.GET_REPORTS]: getReports,
  [Types.GET_REPORTS_SUCCESS]: getReportsSuccess,
  [Types.GET_REPORTS_FAILURE]: getReportsFailure,
  [Types.EXPORT_REPORTS]: exportReports,
  [Types.EXPORT_REPORTS_SUCCESS]: exportReportsSuccess,
  [Types.EXPORT_REPORTS_FAILURE]: exportReportsFailure,
  [Types.CLEAR_REPORTS]: clearReports,
  [Types.GET_SALES]: getSales,
  [Types.GET_SALES_SUCCESS]: getSalesSuccess,
  [Types.GET_SALES_FAILURE]: getSalesFailure,
  [Types.GET_SALES_ITEM_DETAILS]: getSalesItemDetails,
  [Types.GET_SALES_ITEM_DETAILS_SUCCESS]: getSalesItemDetailsSuccess,
  [Types.GET_SALES_ITEM_DETAILS_FAILURE]: getSalesItemDetailsFailure,
  [Types.GET_SALES_STATUS]: getSalesStatus,
  [Types.GET_SALES_STATUS_SUCCESS]: getSalesStatusSuccess,
  [Types.GET_SALES_STATUS_FAILURE]: getSalesStatusFailure
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/reducers/ReportsReducer.js